import * as React from "react"
const UnsprayedGroundSmall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 1163 820"
    }}
    viewBox="0 0 1163 820"
    {...props}>
    <style>
      {
        ".ugs_st0{display:none}.ugs_st1{display:inline}.ugs_st4{fill:none;stroke:#2d0e5e;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ugs_st15,.ugs_st23{fill:#fff}.ugs_st23{display:inline}.ugs_st37{fill:#eb4848;stroke:#2d0e5e;stroke-width:2;stroke-linejoin:round}.ugs_st37,.ugs_st38,.ugs_st42,.ugs_st43,.ugs_st46{stroke-linecap:round;stroke-miterlimit:10}.ugs_st38{fill:none;stroke:#2d0e5e;stroke-width:2}.ugs_st42,.ugs_st43,.ugs_st46{stroke:#111616;stroke-linejoin:round}.ugs_st42{fill:none;stroke-width:1.5}.ugs_st43,.ugs_st46{fill:#111616}.ugs_st46{fill:#ded3b3;stroke:#5b480e;stroke-width:6}.ugs_st60{fill:#4d4d4d}.ugs_st61,.ugs_st62{fill:#2e2e89;stroke:#2e2e89;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ugs_st62{fill:none;stroke:#4d4d4d}.ugs_st68{display:inline;fill:#dbf0ec}.ugs_st77{fill:#a4aa5d}.ugs_st78{fill:#c3dd8b}.ugs_st103,.ugs_st104,.ugs_st105,.ugs_st106{fill:#a5c2d9;stroke:#a5c2d9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ugs_st104,.ugs_st105,.ugs_st106{fill:#072e44;stroke:#072e44}.ugs_st105,.ugs_st106{fill:#13496d;stroke:#13496d}.ugs_st106{fill:none}.ugs_st107{fill:#13496d}.ugs_st108{fill:#c0e4f3;stroke:#c0e4f3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ugs_st114{fill:#477c4e}.ugs_st129{fill:#cab798}.ugs_st130{fill:#a38065}.ugs_st131{fill:#9f7b60}.ugs_st132{fill:#825550}.ugs_st133{fill:#26662c}.ugs_st135{fill:#334724}.ugs_st136{fill:#6c5410}.ugs_st137{fill:#7ab729}.ugs_st138{fill:#edb56b}.ugs_st139{fill:#b6753a}.ugs_st145{fill:#ff461d}.ugs_st176{fill:#4e841a;stroke:#4e841a;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
      }
    </style>
    <g id="Lager_5">
      <path
        d="M1156.9 410h-10.8c-2.1-1.9-4.5-3.6-7.2-5l-517-271.5c-25.6-13.5-56.9-13.5-82.5 0L22.5 405c-2.7 1.4-5.1 3.1-7.2 5H4.4v23.9c0 11.3 6 22.6 18.1 29l516.9 271.5c25.6 13.5 56.9 13.5 82.5 0l516.9-271.5c12-6.3 18.1-17.6 18.1-29V410z"
        style={{
          fill: "#5b361d"
        }}
      />
      <defs>
        <path
          id="SVGID_00000176006292875984484160000011538169652901903254_"
          d="M1016.8-1078.8h-923c-66.3 0-120-53.7-120-120v-580c0-66.3 53.7-120 120-120h923c66.3 0 120 53.7 120 120v580c0 66.3-53.8 120-120 120z"
        />
      </defs>
      <clipPath id="SVGID_00000057870504271502323280000005374278361657950133_">
        <use
          xlinkHref="#SVGID_00000176006292875984484160000011538169652901903254_"
          style={{
            overflow: "visible"
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            "url(#SVGID_00000057870504271502323280000005374278361657950133_)"
        }}>
        <path
          d="M1740.7-969.6 572.4-385.5l1168.3 584.1 1168.2-584.1z"
          className="ugs_st136"
        />
        <path
          d="M929.8-536.2 2043.4 22.3l-22.7 11.4L907.1-524.9zM942.5-542.6l1114 558.4 21.8-10.9L964.1-553.4zM647.7-395.7l1113.6 558.6-22.7 11.4L625-384.3zM660.4-402l1114 558.4 21.8-10.9L682-412.8zM695.6-419.6 1809 139.1l22.1-11.1L717.4-430.5zM1843.6 121.8l-1112.8-559 22-11L1866 110.6zM1878.7 104.2l-1112.8-559 22-11L1901 93zM1913.8 86.7 801-472.3l22-11L1936.1 75.5zM1948.9 69.1 836.1-489.8l22-11L1970.8 57.8zM1985.8 50.7 871.1-507.4l23.2-11.5L2007.9 39.6z"
          className="ugs_st137"
        />
      </g>
      <defs>
        <path
          id="SVGID_00000150802189632818402920000004489806311268639106_"
          d="M539.4 109.5 22.5 381c-24.1 12.7-24.1 45.3 0 57.9l516.9 271.5c25.6 13.5 56.9 13.5 82.5 0L1138.8 439c24.1-12.7 24.1-45.3 0-57.9L621.9 109.5c-25.6-13.5-56.9-13.5-82.5 0z"
        />
      </defs>
      <clipPath id="SVGID_00000114035160669862844960000007058617837732590742_">
        <use
          xlinkHref="#SVGID_00000150802189632818402920000004489806311268639106_"
          style={{
            overflow: "visible"
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            "url(#SVGID_00000114035160669862844960000007058617837732590742_)"
        }}>
        <path
          d="m11.5-509.6-563.9 281.9L11.5 54.9 576-227.4z"
          className="ugs_st136"
        />
        <path
          d="m-.6 37 1101.7-551.5 11 5.5L10.5 42.5zM-17.3 28.6l1101.7-551.5 11 5.6L-6.3 34.2zM-34.3 20.1l1101.5-551.4 11.2 5.5L-23.2 25.7zM-51.3 11.7l1101.7-551.5 11 5.5L-40.2 17.2zM-68.2 3.2l1101.6-551.5 11.1 5.5L-57.2 8.7z"
          className="ugs_st137"
        />
        <path
          d="M-136.2-23.5v516l68 171.8 661.4-323.2z"
          className="ugs_st135"
        />
        <path
          d="M1139.3-509 575.4-227.1l563.9 282 563.9-282z"
          className="ugs_st130"
        />
        <path
          d="M575.4-227.1 11.5 54.9l563.9 281.9 563.9-281.9z"
          className="ugs_st130"
        />
        <path
          d="m291.9 182.8 1101.7-551.5 11 5.6L303 188.4zM275.2 174.5 1376.9-377l11 5.5L286.3 180zM258.2 166l1101.5-551.4 11.2 5.4L269.3 171.5zM241.3 157.5 1342.9-394l11 5.5L252.3 163zM224.3 149l1101.6-551.5 11.1 5.5L235.3 154.5zM206.9 140.3l1101.6-551.5 11 5.5L217.9 145.8zM189.9 131.8l1101.7-551.5 11 5.5L201 137.3zM173 123.4l1101.6-551.5 11.1 5.5L184.1 128.9zM155.8 115l1101.7-551.5 11 5.5L166.9 120.5zM139.1 106.6l1101.7-551.5 11 5.5L150.2 112.1zM122.1 98.1l1101.5-551.4 11.2 5.4L133.2 103.6zM105.2 89.6l1101.6-551.5 11 5.5L116.2 95.1zM88.2 81.1l1101.6-551.5 11.1 5.5L99.2 86.6zM70.8 72.4l1101.6-551.5 11.1 5.5L81.8 77.9zM53.8 63.9l1101.7-551.5 11 5.6L64.9 69.5zM36.9 55.5 1138.5-496l11.1 5.5L48 61zM427.7 250.9l1101.6-551.5 11.1 5.5L438.7 256.5zM411 242.6l1101.6-551.5 11 5.5L422 248.1zM394 234.1l1101.5-551.5 11.2 5.5L405 239.6zM377 225.6l1101.7-551.5 11 5.5L388 231.1zM360 217.1l1101.7-551.5 11 5.5L371.1 222.6zM342.6 208.4l1101.7-551.5 11 5.5L353.7 213.9zM325.7 199.9l1101.6-551.5 11 5.5L336.7 205.4zM308.7 191.4l1101.7-551.5 11.1 5.6L319.8 197zM563.3 319.6 1665-231.9l11 5.5L574.4 325.1zM546.6 311.2l1101.7-551.5 11 5.5L557.7 316.7zM529.6 302.7l1101.5-551.4 11.2 5.4L540.7 308.2zM512.7 294.2l1101.6-551.5 11 5.5L523.7 299.7zM495.7 285.7l1101.6-551.5 11.1 5.6L506.7 291.3zM478.3 277l1101.6-551.5 11 5.5L489.3 282.5zM461.3 268.5 1563-282.9l11 5.5L472.4 274.1zM444.4 260.1 1546-291.4l11.1 5.5L455.5 265.6z"
          className="ugs_st129"
        />
        <path d="M6.1 12.7 1139.3-554v-10.3L6.1 2.4z" className="ugs_st138" />
        <path d="M1139.3-554 6.1 12.7v-4l1133.2-566.8z" className="ugs_st139" />
        <path d="m108.4-63.3.1 71.3 9.3-5.4-.1-71.2z" className="ugs_st138" />
        <path d="m108.5 8-.1-71.3 3.7-2.1.1 71.3z" className="ugs_st139" />
        <path d="m20.7-19.2.1 71.3 9.2-5.4-.1-71.3z" className="ugs_st138" />
        <path d="m20.8 52.1-.1-71.3 3.6-2.1.2 71.2z" className="ugs_st139" />
        <path
          d="m6.1 39.2 1133.2-566.7v-10.3L6.1 28.9z"
          className="ugs_st138"
        />
        <path
          d="M1139.3-527.5 6.1 39.2v-4l1133.2-566.7z"
          className="ugs_st139"
        />
        <path
          d="m1703.2-227.1-563.9 282 692.1 346 435.7-346z"
          className="ugs_st130"
        />
        <path
          d="m1148.3 44.9 534.8-267.3 11.1 5.5-534.8 267.4z"
          className="ugs_st129"
        />
        <path
          d="m1139.4-1.2 692 346.1v10.3L1139.3 9.1z"
          className="ugs_st138"
        />
        <path d="m1139.4 5.1 692 346v4.1L1139.3 9.1z" className="ugs_st139" />
        <path d="M1831.4 371.4v9.9l-692-345.7V25.3z" className="ugs_st138" />
        <path d="M1831.4 376v5.3l-692-345.7v-4z" className="ugs_st139" />
        <path
          d="m1703.3 336.8-563.9 282 563.9 281.9 563.9-281.9z"
          className="ugs_st136"
        />
        <path d="M728.1-43.8v32.9L679.5 8.7v-32.2z" className="ugs_st103" />
        <path
          d="M647.9 7.8 636.4 2c-3-2-4.8-6-4.8-11.5 0-11.8 8.3-26.3 18.4-32.4 5.1-3.1 9.8-3.4 13.1-1.5l5.9 2.9"
          className="ugs_st106"
        />
        <path
          d="M659.1-19.3v-14.1l10-7.2-5.9-2.9c-3.3-1.9-8-1.6-13.1 1.5-10.2 6.1-18.4 20.6-18.4 32.4 0 5.6 1.8 9.5 4.8 11.5L648 7.7c3.3 1.6 7.7 1.2 12.6-1.8 1.8-1.1 3.6-2.4 5.2-4l-6.7-3.2v-18z"
          className="ugs_st107"
        />
        <path
          d="M667.3-39.4c-2.1.3-4.4 1.1-6.8 2.6-10.2 6.1-18.4 20.6-18.4 32.4 0 11.8 8.3 16.5 18.4 10.4 1.8-1.1 3.6-2.4 5.2-4L659-1.2v-32.2l8.3-6z"
          className="ugs_st104"
        />
        <path
          d="m726.9-11.6-9.6-4.8c-3.3-1.9-8-1.6-13.1 1.5-10.2 6.1-18.4 20.6-18.4 32.4 0 5.6 1.8 9.5 4.8 11.5l11.5 5.8c3.3 1.6 7.7 1.2 12.6-1.8 10.2-6.1 18.4-20.6 18.4-32.4 0-6.2-2.4-10.5-6.2-12.2z"
          className="ugs_st107"
        />
        <path
          d="m702.1 34.9-11.5-5.8c-3-2-4.8-6-4.8-11.5 0-11.8 8.3-26.3 18.4-32.4 5.1-3.1 9.8-3.4 13.1-1.5l9.6 4.8"
          className="ugs_st106"
        />
        <path
          d="M679.5-23.5V8.7l-20.4-10v-32.1l20.4 9.9"
          className="ugs_st105"
        />
        <ellipse
          cx={714.7}
          cy={11.8}
          className="ugs_st104"
          rx={26.4}
          ry={14.9}
          transform="rotate(-60.264 714.73 11.756)"
        />
        <ellipse
          cx={714.7}
          cy={11.8}
          className="ugs_st108"
          rx={14.7}
          ry={8.3}
          transform="rotate(-60.264 714.73 11.756)"
        />
        <ellipse
          cx={714.7}
          cy={11.8}
          className="ugs_st107"
          rx={6.5}
          ry={3.7}
          transform="rotate(-60.264 714.73 11.756)"
        />
        <path
          d="m803.5-62.6-13-6.5c-4.5-2.6-10.9-2.1-17.8 2-13.8 8.3-25.1 28-25.1 44.1 0 7.6 2.5 13 6.6 15.7L769.8.6c4.5 2.2 10.5 1.6 17.1-2.4 13.8-8.3 25.1-28 25.1-44.1 0-8.6-3.3-14.5-8.5-16.7z"
          className="ugs_st107"
        />
        <path
          d="m769.8.6-15.6-7.9c-4.1-2.7-6.6-8.1-6.6-15.7 0-16.1 11.2-35.8 25.1-44.1 7-4.2 13.3-4.6 17.8-2l13 6.5"
          className="ugs_st106"
        />
        <ellipse
          cx={786.9}
          cy={-30.9}
          className="ugs_st104"
          rx={35.9}
          ry={20.3}
          transform="rotate(-60.264 786.933 -30.87)"
        />
        <path
          d="M1139.3 54.9 575.4 336.8l563.9 282 563.9-282z"
          className="ugs_st136"
        />
        <path
          d="m575.4 336.8-597.9 299 597.9 264.9 563.9-281.9z"
          className="ugs_st136"
        />
        <path
          d="m747.9 264.1 914.8 458-11 5.5-914.8-458zM754 261l915 457.9 10.5-5.2-915-457.9zM771 252.5l914.7 458.1 10.7-5.4-914.8-457.9zM1702.4 702.2 788 244l10.6-5.3 914.6 458.1zM1719.4 693.7 805 235.5l10.6-5.3 914.5 458.2zM1736.3 685.3 821.9 227.1l10.6-5.3 914.6 458.1zM1753.2 676.8 838.8 218.6l10.6-5.3 914.4 458zM1771.1 667.9 855.7 210.2l11.2-5.6 914.8 458zM883.9 196l914.8 458-10.9 5.5-914.9-458zM890 192.9l915 457.9 10.5-5.2-915-457.9zM907 184.5l914.7 458 10.7-5.4-914.8-457.9zM1838.4 634.1 924.1 175.9l10.6-5.3 914.5 458.1zM1855.4 625.7 941 167.5l10.6-5.3 914.6 458.1zM1872.3 617.2 957.9 159l10.6-5.3 914.6 458.1zM1889.2 608.7 974.9 150.5l10.6-5.3 914.3 458zM1907.1 599.8 991.8 142.1l11.2-5.6 914.8 458zM1021.5 127.3l914.7 458-10.9 5.5-914.8-458zM1027.6 124.3l915 457.9 10.5-5.3L1038 119zM1044.6 115.8l914.7 458 10.7-5.3-914.9-458zM1976 565.5l-914.4-458.2 10.6-5.4 914.6 458.2zM1992.9 557 1078.5 98.8l10.6-5.3 914.6 458.1zM2009.8 548.5 1095.5 90.3l10.6-5.3 914.5 458.1zM2026.8 540.1 1112.4 81.8l10.6-5.3 914.4 458.1zM2044.6 531.1 1129.3 73.4l11.2-5.6 914.8 458zM617.8 328.9l915 457.9 10.6-5.3-915.1-457.8zM634.8 320.4l914.7 458 10.7-5.3-914.8-458zM1566.3 770.1 651.9 311.9l10.6-5.3L1577 764.7zM1583.2 761.6 668.8 303.4l10.6-5.3L1594 756.2zM1600.1 753.1 685.7 294.9l10.6-5.3 914.6 458.1zM1617.1 744.7 702.7 286.5l10.6-5.3 914.4 458zM1634.9 735.8 719.6 278l11.2-5.6 914.8 458z"
          className="ugs_st137"
        />
        <path
          d="M1139.3 618.8 575.4 900.7l563.9 282 563.9-282z"
          className="ugs_st136"
        />
        <path
          d="m754 824.9 537.8 269.6 10.5-5.3-537.8-269.5zM771 816.4l537.5 269.7 10.7-5.3-537.6-269.6zM1325.2 1077.7 788 807.9l10.6-5.3 537.4 269.7zM1342.1 1069.3 805 799.5l10.6-5.4 537.3 269.8zM1359 1060.8 821.9 791l10.6-5.3 537.3 269.7zM1376 1052.3 838.8 782.5l10.6-5.3 537.2 269.7zM1393.8 1043.4 855.7 774.1l11.2-5.6 537.6 269.6zM883.9 759.9l537.6 269.6-11 5.5-537.6-269.6zM890 756.8l537.8 269.6 10.5-5.3-537.8-269.5zM907 748.4l537.5 269.6 10.7-5.3-537.6-269.6zM1461.2 1009.7 924.1 739.8l10.6-5.3 537.3 269.8zM1478.1 1001.2 941 731.4l10.6-5.3 537.3 269.7zM1495.1 992.7 957.9 722.9l10.6-5.3 537.4 269.7zM1512 984.3 974.9 714.4l10.6-5.3 537.1 269.7zM1529.8 975.3 991.8 706l11.2-5.6L1540.5 970zM1021.5 691.2 1559 960.8l-10.9 5.5-537.6-269.6zM1027.6 688.2l537.7 269.5 10.5-5.3L1038 682.9zM1044.6 679.7 1582 949.3l10.7-5.3-537.6-269.6zM1598.7 941l-537.1-269.8 10.6-5.4 537.3 269.8zM1615.7 932.5l-537.2-269.8 10.6-5.3 537.4 269.7zM1632.6 924l-537.1-269.8 10.6-5.3 537.3 269.8zM1649.5 915.6l-537.1-269.8 10.6-5.4 537.1 269.7zM1667.4 906.7l-538.1-269.4 11.2-5.6 537.6 269.6zM219.2 528.2l537.5 269.6-10.9 5.5-537.6-269.6zM225.3 525.2 763 794.7l10.6-5.3-537.9-269.5zM242.3 516.7l537.4 269.6 10.7-5.3-537.6-269.6zM796.4 778 259.3 508.1l10.6-5.3 537.3 269.8zM813.4 769.5 276.2 499.7l10.7-5.3 537.3 269.7zM830.3 761 293.2 491.2l10.6-5.3 537.3 269.7zM847.2 752.6 310.1 482.7l10.6-5.3 537.1 269.7zM865.1 743.7 327 474.3l11.2-5.6 537.6 269.6zM355.2 460.1l537.5 269.7-10.9 5.4-537.6-269.6zM361.3 457.1 899 726.6l10.6-5.3-537.8-269.4zM378.3 448.6l537.5 269.7 10.6-5.4-537.5-269.6zM932.5 709.9 395.3 440.1l10.6-5.3 537.4 269.7zM949.4 701.4 412.3 431.6l10.6-5.3L960.2 696zM966.3 693 429.2 423.1l10.6-5.3 537.3 269.8zM983.3 684.5 446.1 414.7l10.6-5.3L993.9 679zM1001.1 675.6 463 406.2l11.2-5.6 537.6 269.6zM492.7 391.4l537.6 269.7-11 5.5-537.5-269.7zM498.8 388.4l537.8 269.5 10.5-5.2-537.8-269.5zM515.8 379.9l537.5 269.7 10.7-5.4-537.6-269.6z"
          className="ugs_st137"
        />
        <path
          d="M1134.7 672 532.9 371.4l10.6-5.3 601.9 300.5zM1151.6 663.5 549.8 362.9l10.6-5.3 602 300.5zM1168.5 655 566.7 354.5l10.6-5.4 602 300.5zM1185.5 646.6 583.7 346l10.6-5.3 601.8 300.4zM1515.9 795.3 600.6 337.5l11.2-5.6 914.8 458zM83 596.1l537.5 269.6-10.9 5.5L72 601.6zM89.1 593l537.8 269.5 10.5-5.2L99.6 587.8zM106.1 584.5l537.5 269.7 10.7-5.4-537.6-269.6zM660.3 845.8 123.1 576l10.7-5.3 537.3 269.7zM677.2 837.4 140.1 567.5l10.6-5.3L688 832zM694.1 828.9 157 559.1l10.6-5.3 537.3 269.7zM711.1 820.4 173.9 550.6l10.7-5.3 537.1 269.6zM728.9 811.5l-538-269.3 11.1-5.6 537.6 269.6zM-36 655.6l537.5 269.6-10.9 5.5L-47 661.1zM-29.9 652.5 507.8 922l10.6-5.2-537.9-269.5zM-12.9 644l537.4 269.7 10.7-5.4L-2.4 638.7zM541.3 905.3 4.1 635.5l10.6-5.3L552 899.9zM558.2 896.9 21 627l10.7-5.3L569 891.5zM575.1 888.4 38 618.6l10.6-5.3L585.9 883zM592.1 879.9 54.9 610.1l10.6-5.3 537.2 269.6z"
          className="ugs_st137"
        />
        <path
          d="M158.1 214h-17v31.4c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3V214z"
          className="ugs_st131"
        />
        <path
          d="M158.1 226.7c-2.7.1-5.7.2-8.6.2s-5.7-.1-8.4-.2V214h17v12.7z"
          className="ugs_st132"
        />
        <path
          d="M158.1 214v31.4c0 1-1.9 1.9-4.6 2.3V214h4.6z"
          className="ugs_st132"
        />
        <path
          d="m191.4 207.1-19.3-51.7H127l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1-.1 0-.3-.1-.6z"
          className="ugs_st114"
        />
        <path
          d="m172.1 155.4 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
          className="ugs_st133"
        />
        <path
          d="M180.3 153v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0L118.8 153c-.1.2-.1.5-.1.8 0 4.5 13.8 8.1 30.9 8.1s30.9-3.6 30.9-8.1c0-.3-.1-.5-.2-.8z"
          className="ugs_st114"
        />
        <path
          d="M151.5 76.9c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9 0-18.9-9.1-61.2-9.1-61.2z"
          className="ugs_st133"
        />
        <path
          d="M45.5 291.4h-17v31.4c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3v-31.4z"
          className="ugs_st131"
        />
        <path
          d="M45.5 304.1c-2.7.1-5.7.2-8.6.2-2.9 0-5.7-.1-8.4-.2v-12.7h17v12.7z"
          className="ugs_st132"
        />
        <path
          d="M45.5 291.4v31.4c0 1-1.9 1.9-4.6 2.3v-33.6h4.6z"
          className="ugs_st132"
        />
        <path
          d="m78.7 284.5-19.3-51.7H14.3l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1-.1 0-.4-.1-.6z"
          className="ugs_st114"
        />
        <path
          d="m59.4 232.8 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
          className="ugs_st133"
        />
        <path
          d="M67.7 230.4v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0L6.1 230.4c-.1.2-.1.5-.1.7 0 4.5 13.8 8.1 30.9 8.1s30.9-3.6 30.9-8.1c0-.2 0-.5-.1-.7z"
          className="ugs_st114"
        />
        <path
          d="M38.8 154.3c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9 0-18.9-9.1-61.2-9.1-61.2z"
          className="ugs_st133"
        />
        <path
          d="M3.8 439.7-15.5 388h-45.1l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c22-.1 39.4-4.4 39.4-9.6 0-.2-.1-.5-.2-.8z"
          className="ugs_st114"
        />
        <path
          d="m-15.5 388.1 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
          className="ugs_st133"
        />
      </g>
      <path
        d="M589.3 695.3c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.1 3.5-1 3.7-2.1z"
        className="ugs_st135"
      />
      <path
        d="M581.1 627.6c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.1 3.6-1 3.7-2.1z"
        className="ugs_st145"
      />
      <path
        d="M475 633c.2-1.4-1.7-2.5-4.3-2.5h-.3c-.2-.8-1.5-1.5-3.2-1.5-1.7 0-3.1.6-3.6 1.5h-.1c-2.5 0-4.8 1.1-4.9 2.5-.2 1.2 1.3 2.2 3.3 2.4-.2.2-.3.5-.3.7-.2 1.4 1.7 2.5 4.3 2.5s4.8-1.1 4.9-2.5c0-.3 0-.5-.1-.7 2.3-.2 4.1-1.2 4.3-2.4zM722.8 543.3c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.2 3.5-1.1 3.7-2.1zM695.3 605.6c.2-1.4-1.7-2.5-4.3-2.5h-.3c-.2-.8-1.5-1.5-3.2-1.5-1.7 0-3.1.6-3.6 1.5h-.1c-2.5 0-4.8 1.1-4.9 2.5-.2 1.2 1.3 2.2 3.3 2.4-.2.2-.3.5-.3.7-.2 1.4 1.7 2.5 4.3 2.5 2.5 0 4.8-1.1 4.9-2.5 0-.3 0-.5-.1-.7 2.3-.2 4.1-1.2 4.3-2.4zM818.3 524.3c.2-1.4-1.7-2.5-4.3-2.5h-.3c-.2-.8-1.5-1.5-3.2-1.5-1.7 0-3.1.6-3.6 1.5h-.1c-2.5 0-4.8 1.1-4.9 2.5-.2 1.2 1.3 2.2 3.3 2.4-.2.2-.3.5-.3.7-.2 1.4 1.7 2.5 4.3 2.5 2.5 0 4.8-1.1 4.9-2.5 0-.3 0-.5-.1-.7 2.4-.2 4.2-1.2 4.3-2.4z"
        className="ugs_st135"
      />
      <path
        d="M813.4 596c.2-1.4-1.7-2.5-4.3-2.5h-.3c-.2-.8-1.5-1.5-3.2-1.5-1.7 0-3.1.6-3.6 1.5h-.1c-2.5 0-4.8 1.1-4.9 2.5-.2 1.2 1.3 2.2 3.3 2.4-.2.2-.3.5-.3.7-.2 1.4 1.7 2.5 4.3 2.5 2.5 0 4.8-1.1 4.9-2.5 0-.3 0-.5-.1-.7 2.3-.2 4.1-1.2 4.3-2.4z"
        className="ugs_st145"
      />
      <path
        d="M768.6 463.4c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.2 3.6-1.1 3.7-2.1z"
        className="ugs_st135"
      />
      <path
        d="M862 459.7c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2 2.2 0 4.2-1 4.4-2.2 0-.2 0-.4-.1-.6 2-.1 3.6-1 3.7-2.1z"
        className="ugs_st145"
      />
      <path
        d="M922.6 519.6c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.1 3.6-1 3.7-2.1zM887.6 391.6c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.2 3.5-1.1 3.7-2.1zM975.5 365c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.1 3.6-1 3.7-2.1zM974.6 310.7c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 1.9-.1 3.5-1 3.7-2.1zM953.2 437.1c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2s4.2-1 4.4-2.2c0-.2 0-.4-.1-.6 2-.2 3.6-1 3.7-2.1zM1039.9 462.4c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2 2.2 0 4.2-1 4.4-2.2 0-.2 0-.4-.1-.6 2-.1 3.6-1 3.7-2.1z"
        className="ugs_st135"
      />
      <path
        d="M1053.9 406c.2-1.2-1.5-2.2-3.8-2.2h-.2c-.2-.7-1.3-1.3-2.8-1.3-1.5 0-2.8.6-3.1 1.3h-.1c-2.2 0-4.2 1-4.4 2.2-.1 1.1 1.1 1.9 2.9 2.1-.1.2-.3.4-.3.6-.2 1.2 1.5 2.2 3.8 2.2 2.2 0 4.2-1 4.4-2.2 0-.2 0-.4-.1-.6 2-.1 3.6-1 3.7-2.1z"
        className="ugs_st145"
      />
      <path
        d="M430.2 577.7c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 1.9-.2 3.5-1 3.7-2z"
        className="ugs_st135"
      />
      <path
        d="M422 514.5c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 2-.2 3.6-1 3.7-2z"
        className="ugs_st145"
      />
      <path
        d="M315.8 519.5c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3s4.8-1 4.9-2.3c0-.2 0-.5-.1-.7 2.4-.2 4.2-1.1 4.3-2.3zM563.7 435.8c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 1.9-.2 3.5-1 3.7-2zM536.2 494c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3 2.5 0 4.8-1 4.9-2.3 0-.2 0-.5-.1-.7 2.3-.2 4.1-1.2 4.3-2.3zM463.8 446.6c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3s4.8-1 4.9-2.3c0-.2 0-.5-.1-.7 2.3-.2 4.1-1.1 4.3-2.3zM348.5 581.5c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3s4.8-1 4.9-2.3c0-.2 0-.5-.1-.7 2.3-.2 4.1-1.1 4.3-2.3zM659.2 418.1c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3 2.5 0 4.8-1 4.9-2.3 0-.2 0-.5-.1-.7 2.3-.2 4.1-1.2 4.3-2.3z"
        className="ugs_st135"
      />
      <path
        d="M654.2 485c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3 2.5 0 4.8-1 4.9-2.3 0-.2 0-.5-.1-.7 2.4-.2 4.2-1.1 4.3-2.3z"
        className="ugs_st145"
      />
      <path
        d="M536.2 563.3c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3 2.5 0 4.8-1 4.9-2.3 0-.2 0-.5-.1-.7 2.3-.2 4.1-1.2 4.3-2.3zM637.9 554.4c.2-1.3-1.7-2.3-4.3-2.3h-.3c-.2-.8-1.5-1.4-3.2-1.4-1.7 0-3.1.6-3.6 1.4h-.1c-2.5 0-4.8 1-4.9 2.3-.2 1.1 1.3 2 3.3 2.3-.2.2-.3.4-.3.7-.2 1.3 1.7 2.3 4.3 2.3 2.5 0 4.8-1 4.9-2.3 0-.2 0-.5-.1-.7 2.4-.2 4.2-1.2 4.3-2.3z"
        className="ugs_st135"
      />
      <path
        d="M609.5 361.3c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 1.9-.2 3.5-1 3.7-2z"
        className="ugs_st145"
      />
      <path
        d="M702.9 357.9c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 2-.2 3.6-1 3.7-2zM763.5 413.7c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 1.9-.1 3.5-.9 3.7-2zM728.5 294.3c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 1.9-.2 3.5-1 3.7-2zM816.4 269.5c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 2-.1 3.6-1 3.7-2zM895 253.1c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 2-.2 3.5-1 3.7-2zM794.1 336.8c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 2-.2 3.6-1 3.7-2zM880.8 360.4c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 2-.2 3.6-1 3.7-2z"
        className="ugs_st135"
      />
      <path
        d="M894.8 307.8c.2-1.1-1.5-2-3.8-2h-.2c-.2-.7-1.3-1.2-2.8-1.2-1.5 0-2.8.5-3.1 1.2h-.1c-2.2 0-4.2.9-4.4 2-.1 1 1.1 1.8 2.9 2-.1.2-.3.4-.3.6-.2 1.1 1.5 2 3.8 2s4.2-.9 4.4-2c0-.2 0-.4-.1-.6 2-.2 3.6-1 3.7-2z"
        className="ugs_st145"
      />
      <path
        d="M251.1 301.6h-17V333c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3v-31.4z"
        className="ugs_st131"
      />
      <path
        d="M251.1 314.3c-2.7.1-5.7.2-8.6.2s-5.7-.1-8.4-.2v-12.7h17v12.7z"
        className="ugs_st132"
      />
      <path
        d="M251.1 301.6V333c0 1-1.9 1.9-4.6 2.3v-33.6h4.6z"
        className="ugs_st132"
      />
      <path
        d="M284.3 294.7 265 243h-45.1l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1-.1 0-.3-.1-.6z"
        className="ugs_st114"
      />
      <path
        d="m265 243 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
        className="ugs_st133"
      />
      <path
        d="M273.3 240.6v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0l-26.5 73.5c-.1.2-.1.5-.1.8 0 4.5 13.8 8.1 30.9 8.1s30.9-3.6 30.9-8.1c0-.3 0-.5-.1-.8z"
        className="ugs_st114"
      />
      <path
        d="M244.4 164.5c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9.1-18.9-9.1-61.2-9.1-61.2z"
        className="ugs_st133"
      />
      <path
        d="M359.5 254.7h-17V286c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3v-31.3z"
        className="ugs_st131"
      />
      <path
        d="M359.5 267.4c-2.7.1-5.7.2-8.6.2s-5.7-.1-8.4-.2v-12.7h17v12.7z"
        className="ugs_st132"
      />
      <path
        d="M359.5 254.7V286c0 1-1.9 1.9-4.6 2.3v-33.6h4.6z"
        className="ugs_st132"
      />
      <path
        d="m392.7 247.8-19.3-51.7h-45.1l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1-.1 0-.3-.1-.6z"
        className="ugs_st114"
      />
      <path
        d="m373.4 196.1 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
        className="ugs_st133"
      />
      <path
        d="M381.7 193.7v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0l-26.5 73.5c-.1.2-.1.5-.1.8 0 4.5 13.8 8.1 30.9 8.1 17.1 0 30.9-3.6 30.9-8.1 0-.3 0-.6-.1-.8z"
        className="ugs_st114"
      />
      <path
        d="M352.8 117.6c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9.1-18.9-9.1-61.2-9.1-61.2z"
        className="ugs_st133"
      />
      <path
        d="M89.7 399.3h-17v31.4c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3v-31.4z"
        className="ugs_st131"
      />
      <path
        d="M89.7 412c-2.7.1-5.7.2-8.6.2-2.9 0-5.7-.1-8.4-.2v-12.7h17V412z"
        className="ugs_st132"
      />
      <path
        d="M89.7 399.3v31.4c0 1-1.9 1.9-4.6 2.3v-33.6h4.6z"
        className="ugs_st132"
      />
      <path
        d="m122.9 392.4-19.3-51.7H58.5l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1 0 0-.3-.1-.6z"
        className="ugs_st114"
      />
      <path
        d="m103.6 340.8 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
        className="ugs_st133"
      />
      <path
        d="M111.8 338.3v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0l-26.5 73.5c-.1.2-.1.5-.1.8 0 4.5 13.8 8.1 30.9 8.1s30.9-3.6 30.9-8.1c.1-.3 0-.5-.1-.8z"
        className="ugs_st114"
      />
      <path
        d="M83 262.3c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9 0-19-9.1-61.2-9.1-61.2z"
        className="ugs_st133"
      />
      <path
        d="m604.9 190.6-14 7.1V164l36.3-17.1zM574.7 111c-4.3-2-10-1.4-16.2 2.4-11.1 6.7-20.5 21.1-23.2 34.6l14.4 8c2.4-13.9 12-28.8 23.4-35.7 5.9-3.5 11.4-4.3 15.5-2.7l-13.9-6.6z"
        className="ugs_st103"
      />
      <path
        d="M632.2 105.8v25.5l-5 2.6v-21.2l-22.3 11.5-7.4 36.8-6.6 3 10.2-42.1z"
        className="ugs_st104"
      />
      <path
        d="M601.1 121.9 590.9 164v33.7l-5.8 2.7v-37.5l9.7-40-22.5-10.2-19.5 35.8-1 .8v-9.6l18.2-33.9"
        className="ugs_st105"
      />
      <path d="M551.8 121.9v27.4l-8.1 5.8v-33.2" className="ugs_st104" />
      <ellipse cx={547.8} cy={121.9} className="ugs_st105" rx={4} ry={1.7} />
      <path d="M585.1 162.9v31.4l-46.5 18.8v-30.8z" className="ugs_st103" />
      <path
        d="m508.3 212.2-11-5.6c-2.9-1.9-4.6-5.7-4.6-11.1 0-11.3 7.9-25.2 17.6-31 4.9-2.9 9.3-3.3 12.5-1.4l5.6 2.8"
        className="ugs_st106"
      />
      <path
        d="M519 186.3v-13.5l9.5-6.9-5.6-2.8c-3.2-1.8-7.6-1.5-12.5 1.4-9.7 5.8-17.6 19.7-17.6 31 0 5.3 1.8 9.1 4.6 11.1l11 5.6c3.2 1.5 7.4 1.1 12.1-1.7 1.7-1 3.4-2.3 5-3.8l-6.4-3.1-.1-17.3z"
        className="ugs_st107"
      />
      <path
        d="M526.9 167.1c-2 .3-4.2 1.1-6.5 2.5-9.7 5.8-17.6 19.7-17.6 31s7.9 15.8 17.6 9.9c1.7-1 3.4-2.3 5-3.8l-6.4-3.1v-30.8l7.9-5.7z"
        className="ugs_st104"
      />
      <path
        d="m584 193.7-9.2-4.6c-3.2-1.8-7.6-1.5-12.5 1.4-9.7 5.8-17.6 19.7-17.6 31 0 5.3 1.8 9.1 4.6 11.1l11 5.6c3.2 1.5 7.4 1.1 12.1-1.7 9.7-5.8 17.6-19.7 17.6-31-.1-6.1-2.4-10.2-6-11.8z"
        className="ugs_st107"
      />
      <path
        d="M519 202.2c-4.8 2.1-8.5-.5-8.5-6.2 0-5.8 3.7-12.7 8.4-16.3"
        className="ugs_st108"
      />
      <path
        d="m515.8 178.7 5-2.5c1.9-.9 2.2-4.3.7-7.6s-4.3-5.3-6.2-4.4l-5 2.5"
        className="ugs_st104"
      />
      <path
        d="m560.2 238.2-11-5.6c-2.9-1.9-4.6-5.7-4.6-11.1 0-11.3 7.9-25.2 17.6-31 4.9-2.9 9.3-3.3 12.5-1.4l9.2 4.6"
        className="ugs_st106"
      />
      <path
        d="M538.6 182.3v30.8l-19.6-9.5v-30.8l19.6 9.5"
        className="ugs_st105"
      />
      <path d="m585.1 162.9 9.7-40-22.5-10.2-19.5 35.8" className="ugs_st108" />
      <path d="M538.6 202.5 519 193v-20.2l19.6 9.5z" className="ugs_st104" />
      <path
        d="m601.1 121.9 31.1-16.1v-3.2l-31.1-16.3-31.1 16.3v3.2z"
        className="ugs_st105"
      />
      <ellipse
        cx={572.3}
        cy={216.1}
        className="ugs_st104"
        rx={25.2}
        ry={14.3}
        transform="rotate(-60.264 572.303 216.079)"
      />
      <ellipse
        cx={572.3}
        cy={216.1}
        className="ugs_st108"
        rx={14.1}
        ry={8}
        transform="rotate(-60.264 572.303 216.079)"
      />
      <ellipse
        cx={572.3}
        cy={216.1}
        className="ugs_st107"
        rx={6.3}
        ry={3.5}
        transform="rotate(-60.264 572.303 216.079)"
      />
      <ellipse
        cx={513.1}
        cy={172.7}
        className="ugs_st108"
        rx={3.8}
        ry={6.6}
        transform="rotate(-24.564 513.114 172.711)"
      />
      <path
        d="m519 172.8 33.8-24.3 32.3 14.4-46.5 19.4z"
        className="ugs_st105"
      />
      <path
        d="m545.8 192.8 5-2.5c1.9-.9 2.2-4.3.7-7.6s-4.3-5.3-6.2-4.4l-5 2.5"
        className="ugs_st104"
      />
      <ellipse
        cx={543}
        cy={186.8}
        className="ugs_st108"
        rx={3.8}
        ry={6.6}
        transform="rotate(-24.564 543.044 186.765)"
      />
      <path
        d="M627.2 131.9v-19.2l-22.3 11.5-7.4 36.8 29.7-14.1z"
        className="ugs_st108"
      />
      <path
        d="m657.3 144.9-12.5-6.3c-4.4-2.5-10.4-2.1-17.1 1.9-13.3 7.9-24 26.8-24 42.2 0 7.2 2.4 12.4 6.3 15l14.9 7.6c4.3 2.1 10.1 1.5 16.4-2.3 13.3-7.9 24-26.8 24-42.2.1-8.2-3-13.8-8-15.9z"
        className="ugs_st107"
      />
      <path
        d="m625 205.4-14.9-7.6c-3.9-2.6-6.3-7.8-6.3-15 0-15.4 10.7-34.3 24-42.2 6.7-4 12.7-4.4 17.1-1.9l12.5 6.3"
        className="ugs_st106"
      />
      <path
        d="M624.7 135.2c-11.8 6.1-22 20.2-24.9 33.5l15.1 7.7c2.7-13.2 12.8-27.5 24.5-33.7 2.9-1.5 5.7-2.4 8.2-2.8l-11.1-6.1-11.8 1.4z"
        className="ugs_st104"
      />
      <ellipse
        cx={641.4}
        cy={175.3}
        className="ugs_st104"
        rx={34.4}
        ry={19.5}
        transform="rotate(-60.264 641.429 175.27)"
      />
      <ellipse
        cx={641.4}
        cy={175.3}
        className="ugs_st108"
        rx={19.1}
        ry={10.8}
        transform="rotate(-60.264 641.429 175.27)"
      />
      <ellipse
        cx={641.4}
        cy={175.3}
        className="ugs_st107"
        rx={8.5}
        ry={4.8}
        transform="rotate(-60.264 641.429 175.27)"
      />
      <path
        d="M636.8 132.4c-4.3-2-10-1.4-16.2 2.4-11.1 6.7-20.5 21.1-23.2 34.6l14.4 8c2.4-13.9 12-28.8 23.4-35.7 5.9-3.5 11.4-4.3 15.5-2.7l-13.9-6.6z"
        className="ugs_st103"
      />
      <path
        d="M788.8 174.1 569.7 283.6V294l219.1-109.6z"
        className="ugs_st138"
      />
      <path
        d="M788.8 180.4 569.7 289.9v4.1l219.1-109.6z"
        className="ugs_st139"
      />
      <path d="m765.4 171.5.1 71.3 9.3-5.4-.1-71.3z" className="ugs_st138" />
      <path d="m765.5 242.8-.1-71.3 3.7-2.1.1 71.2z" className="ugs_st139" />
      <path d="m678.2 215.2.1 71.2 9.3-5.3-.1-71.3z" className="ugs_st138" />
      <path d="m678.3 286.4-.1-71.2 3.7-2.2.1 71.3z" className="ugs_st139" />
      <path d="m590.5 258.5.1 71.3 9.2-5.4-.1-71.3z" className="ugs_st138" />
      <path d="m590.6 329.8-.1-71.3 3.6-2.1.1 71.3z" className="ugs_st139" />
      <path d="M569.7 310.1v10.4L788.8 211v-10.4z" className="ugs_st138" />
      <path d="M569.7 316.4v4.1L788.8 211v-4.1z" className="ugs_st139" />
      <path
        d="M324.4 403.8h-17v31.4c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3v-31.4z"
        className="ugs_st131"
      />
      <path
        d="M324.4 416.5c-2.7.1-5.7.2-8.6.2s-5.7-.1-8.4-.2v-12.7h17v12.7z"
        className="ugs_st132"
      />
      <path
        d="M324.4 403.8v31.4c0 1-1.9 1.9-4.6 2.3v-33.6h4.6z"
        className="ugs_st132"
      />
      <path
        d="m357.7 397-19.3-51.7h-45.1l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1-.1 0-.4-.1-.6z"
        className="ugs_st114"
      />
      <path
        d="m338.4 345.3 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
        className="ugs_st133"
      />
      <path
        d="M346.6 342.9v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0L285 342.9c-.1.2-.1.5-.1.8 0 4.5 13.8 8.1 30.9 8.1 17.1 0 30.9-3.6 30.9-8.1.1-.3 0-.6-.1-.8z"
        className="ugs_st114"
      />
      <path
        d="M317.7 266.8c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9.1-19-9.1-61.2-9.1-61.2z"
        className="ugs_st133"
      />
      <path
        d="M464.2 332.6h-17V364c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3v-31.4z"
        className="ugs_st131"
      />
      <path
        d="M464.2 345.3c-2.7.1-5.7.2-8.6.2-2.9 0-5.7-.1-8.4-.2v-12.7h17v12.7z"
        className="ugs_st132"
      />
      <path
        d="M464.2 332.6V364c0 1-1.9 1.9-4.6 2.3v-33.6h4.6z"
        className="ugs_st132"
      />
      <path
        d="m497.5 325.8-19.3-51.7h-45.1l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1-.1 0-.4-.1-.6z"
        className="ugs_st114"
      />
      <path
        d="m478.2 274.1 19.3 51.7c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
        className="ugs_st133"
      />
      <path
        d="M486.4 271.7v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0l-26.5 73.5c-.1.2-.1.5-.1.8 0 4.5 13.8 8.1 30.9 8.1 17.1 0 30.9-3.6 30.9-8.1.1-.3 0-.6-.1-.8z"
        className="ugs_st114"
      />
      <path
        d="M457.5 195.6c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9.1-19-9.1-61.2-9.1-61.2z"
        className="ugs_st133"
      />
      <path
        d="M191.8 446.9h-17v31.4c0 1.4 3.8 2.6 8.5 2.6 1.4 0 2.7-.1 3.9-.3 2.8-.4 4.6-1.3 4.6-2.3v-31.4z"
        className="ugs_st131"
      />
      <path
        d="M191.8 459.6c-2.7.1-5.7.2-8.6.2-2.9 0-5.7-.1-8.4-.2v-12.7h17v12.7z"
        className="ugs_st132"
      />
      <path
        d="M191.8 446.9v31.4c0 1-1.9 1.9-4.6 2.3V447h4.6z"
        className="ugs_st132"
      />
      <path
        d="m225 440-19.3-51.7h-45.1l-19.2 51.4-.1.1c-.1.3-.2.6-.2.8 0 5.4 18.8 9.8 42 9.8h2.7c21.9-.3 39.3-4.6 39.3-9.8.1-.1 0-.3-.1-.6z"
        className="ugs_st114"
      />
      <path
        d="M205.7 388.3 225 440c.1.3.2.5.2.8 0 5.2-17.4 9.5-39.3 9.8 0 0 12.4-14.2 7.9-34-4-17.5-30.5-23.8-30.5-23.8"
        className="ugs_st133"
      />
      <path
        d="M214 385.9v-.1l-26.5-73.4c-1.4-4-7.1-4-8.6 0l-26.5 73.5c-.1.2-.1.5-.1.8 0 4.5 13.8 8.1 30.9 8.1s30.9-3.6 30.9-8.1c0-.3-.1-.6-.1-.8z"
        className="ugs_st114"
      />
      <path
        d="M185.1 309.8c1 .5 1.9 1.3 2.4 2.6l26 72.1v.1c.1.2.1.5.1.7 0 4-11.4 7.1-26.5 7.6 0 0 7.1-6.7 7.1-21.9 0-18.9-9.1-61.2-9.1-61.2z"
        className="ugs_st133"
      />
      <defs>
        <path
          id="SVGID_00000121960022035761954670000003152957949902822023_"
          d="m1894.3 109.5-517 271.5c-24.1 12.7-24.1 45.3 0 57.9l516.9 271.5c25.6 13.5 56.9 13.5 82.5 0l517-271.4c24.1-12.7 24.1-45.3 0-57.9l-516.9-271.5c-25.7-13.6-56.9-13.6-82.5-.1z"
        />
      </defs>
      <clipPath id="SVGID_00000168077928679620214870000003253073028393123497_">
        <use
          xlinkHref="#SVGID_00000121960022035761954670000003152957949902822023_"
          style={{
            overflow: "visible"
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            "url(#SVGID_00000168077928679620214870000003253073028393123497_)"
        }}>
        <path
          d="M828.9-358 415-151 828.9 56.4l414.4-207.2z"
          className="ugs_st136"
        />
        <path
          d="m1215.4-164.1-414 207 414 207.4 414.3-207.2z"
          className="ugs_st136"
        />
        <path
          d="M1007.3 136.8 1816-268l8.1 4-808.7 404.8zM995 130.6l808.7-404.8 8.1 4.1-808.7 404.8zM982.6 124.4l808.5-404.8 8.2 4-808.6 404.9zM970.1 118.2l808.6-404.8 8.1 4-808.6 404.8zM957.6 111.9l808.7-404.8 8.1 4.1L965.7 116zM944.8 105.6l808.7-404.9 8.1 4.1L953 109.6zM932.4 99.3l808.7-404.8 8.1 4.1-808.7 404.8zM920 93.1l808.6-404.8 8.2 4.1L928.1 97.2zM907.4 87l808.7-404.9 8.1 4.1L915.5 91zM895.1 80.8 1703.8-324l8.1 4L903.2 84.9zM882.6 74.6l808.6-404.8 8.2 4L890.8 78.6zM870.2 68.4l808.6-404.9 8.1 4.1L878.3 72.4zM857.7 62.1l808.7-404.8 8.1 4.1L865.8 66.2zM844.9 55.7l808.7-404.8 8.1 4.1L853.1 59.8zM832.5 49.5l808.7-404.8 8.1 4L840.6 53.6zM820.1 43.3l808.6-404.8 8.2 4L828.2 47.4zM1106.9 186.8l808.7-404.9 8.1 4.1-808.6 404.8zM1094.7 180.6l808.6-404.8 8.1 4.1-808.6 404.8zM1082.2 174.4l808.6-404.8 8.2 4-808.7 404.8zM1069.7 168.2l808.7-404.9 8.1 4.1-808.7 404.8zM1057.3 161.9l808.6-404.8 8.1 4.1L1065.4 166zM1044.5 155.5l808.7-404.8 8 4.1-808.6 404.8zM1032 149.3l808.7-404.8 8.1 4-808.6 404.9zM1019.6 143.1l808.7-404.8 8.1 4.1-808.6 404.8zM1156.8 212.3l808.7-404.8 8.1 4L1165 216.4zM1144.1 205.9l808.6-404.8 8.1 4.1L1152.2 210zM1131.6 199.7l808.7-404.8 8.1 4-808.7 404.9zM1119.2 193.5l808.6-404.8 8.2 4-808.7 404.9zM807.8 37.1l808.6-404.8 8.1 4.1L815.9 41.2zM795.3 30.9l808.6-404.8 8.2 4L803.4 35zM782.8 24.7l808.7-404.8 8.1 4L790.9 28.7zM770.4 18.5 1579-386.4l8.1 4.1L778.5 22.5zM757.6 12.1l808.6-404.9 8.1 4.1L765.7 16.1zM745.1 5.8 1553.8-399l8.1 4.1L753.3 9.9zM732.7-.4l808.7-404.8 8.1 4.1L740.9 3.7z"
          className="ugs_st137"
        />
        <path
          d="m1203.4 296.9-14.2-37.9h-33.1l-14.1 37.8v.1c-.1.2-.1.4-.1.6 0 4 13.8 7.2 30.8 7.2h2c16.1-.2 28.9-3.4 28.9-7.2-.1-.2-.1-.4-.2-.6z"
          className="ugs_st114"
        />
        <path
          d="m1189.3 259 14.2 37.9c.1.2.1.4.1.6 0 3.8-12.8 7-28.9 7.2 0 0 9.1-10.4 5.8-24.9-2.9-12.9-22.4-17.5-22.4-17.5"
          className="ugs_st133"
        />
        <path
          d="m1195.3 257.2-19.4-53.9c-1.1-3-5.2-3-6.3 0l-19.5 53.9c-.1.2-.1.4-.1.6 0 3.3 10.2 5.9 22.7 5.9s22.7-2.7 22.7-5.9c0-.2 0-.4-.1-.6z"
          className="ugs_st114"
        />
        <path
          d="M1050.8 600h-12.5v23c0 1 2.8 1.9 6.2 1.9 1 0 2-.1 2.8-.2 2-.3 3.4-.9 3.4-1.7v-23z"
          className="ugs_st131"
        />
        <path
          d="M1050.8 609.3c-2 .1-4.2.2-6.3.2s-4.2 0-6.2-.1V600h12.5v9.3z"
          className="ugs_st132"
        />
        <path
          d="M1050.8 600v23c0 .7-1.4 1.4-3.4 1.7V600h3.4z"
          className="ugs_st132"
        />
        <path
          d="M1075.2 594.9 1061 557h-33.1l-14.1 37.8v.1c-.1.2-.1.4-.1.6 0 4 13.8 7.2 30.8 7.2h2c16.1-.2 28.9-3.4 28.9-7.2-.1-.2-.1-.4-.2-.6z"
          className="ugs_st114"
        />
        <path
          d="m1061 557 14.2 37.9c.1.2.1.4.1.6 0 3.8-12.8 7-28.9 7.2 0 0 9.1-10.4 5.8-24.9-2.9-12.9-22.4-17.5-22.4-17.5"
          className="ugs_st133"
        />
        <path
          d="m1067.1 555.2-19.4-53.9c-1.1-3-5.2-3-6.3 0l-19.5 53.9c-.1.2-.1.4-.1.6 0 3.3 10.2 5.9 22.7 5.9s22.7-2.7 22.7-5.9c0-.2 0-.4-.1-.6z"
          className="ugs_st114"
        />
        <path
          d="M1045.9 499.4c.8.3 1.4 1 1.8 1.9l19.1 52.9v.1c.1.2.1.4.1.5 0 3-8.3 5.2-19.5 5.6 0 0 5.2-4.9 5.2-16 0-14-6.7-45-6.7-45z"
          className="ugs_st133"
        />
        <path
          d="m1209.7 532.8-14.2-37.9h-33.1l-14.1 37.8v.1c-.1.2-.1.4-.1.6 0 4 13.8 7.2 30.8 7.2h2c16.1-.2 28.9-3.4 28.9-7.2-.1-.2-.1-.4-.2-.6z"
          className="ugs_st114"
        />
        <path
          d="M1201.6 493.1c0-.1 0-.1 0 0l-19.4-53.9c-1.1-3-5.2-3-6.3 0l-19.5 53.9c-.1.2-.1.4-.1.6 0 3.3 10.2 5.9 22.7 5.9s22.7-2.7 22.7-5.9c0-.3 0-.5-.1-.6z"
          className="ugs_st114"
        />
      </g>
    </g>
  </svg>
)
export default UnsprayedGroundSmall
